<script setup lang="ts">
import type { ButtonSize } from '@global-types/buttonSize.ts';
import type { ButtonVariant } from '@global-types/buttonVariant';
import type { LinkTarget } from '@global-types/linkTarget';
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  href: string,
  variant?: ButtonVariant,
  size?: ButtonSize,
  target?: LinkTarget,
}>(), {
  size: 'default',
});

const classes = computed<string[]>(() => {
  const classList = [];
  if (props.variant) {
    classList.push(`btn--${props.variant}`);
  }

  classList.push(`btn--${props.size}`);

  return classList;
});
</script>

<template>
  <a
    class="btn"
    :class="classes"
    :href="props.href"
    :target="props.target"
  >
    <slot />
  </a>
</template>
